import _City from '../utils/city.js'

let RELEASE = true
export const isBeijing = false //是否是北京版，两者登录页，主页的尾脚信息不同

// export const domain = RELEASE ? 'meat.chinausmeat.com' : 'csw1009.ciicloud.cn:35880'
export const domain = RELEASE ? 'meat.chinausmeat.com' : 'meat1.chinausmeat.com'
    // export const baseUrl = RELEASE ? `https://${domain}` : `http://${domain}`
export const baseUrl = RELEASE ? `https://${domain}` : `https://${domain}`
    // export const meatUrl = RELEASE ? `https://${domain}/meat` : `http://${domain}/meat`
export const meatUrl = RELEASE ? `https://${domain}/meat` : `https://${domain}/meat`
export const registerUrl = `${meatUrl}/user/register` // 注册

export const checkLoginUrl = `${meatUrl}/user/check` //检查用户的登录状态

export const sendCodeMessageUrl = `${meatUrl}/user/sendMessage` //发送短信验证码

//北京协议
export const userServiceDell = `https://www.chinausmeat.com/legal-agreement/meat/service.html`
export const userPrivacyDell = `https://www.chinausmeat.com/legal-agreement/meat/privacy.html`
export const userPayDell = `https://www.chinausmeat.com/legal-agreement/meat/pay.html`
export const userCertDell = `https://www.chinausmeat.com/legal-agreement/meat/cert.html`
export const userRegistDell = `https://www.chinausmeat.com/legal-agreement/meat/regist.html`

//湖南协议
export const userServiceDellHN = `https://www.chinausmeat.com/legal-agreement/meat/service_hn.html`
export const userCertDellHN = `https://www.chinausmeat.com/legal-agreement/meat/cert_hn.html`
export const userRegistDellHN = `https://www.chinausmeat.com/legal-agreement/meat/regist_hn.html`
export const userPrivacyDellHN = `https://www.chinausmeat.com/legal-agreement/meat/privacy_hn.html`

export const importStockUrl = `${meatUrl}/stock/importStock` //导入白条到库存中：选择Excel文件，点击【导入】白条到库存中；
    // 轮播图
export const queryBannerListUrl = `${meatUrl}/home/getBannerList`
    // 分类
export const queryAllClassCategry = `${meatUrl}/goods/type/getAlls`
    // 商品
export const queryAllGoodsList = `${meatUrl}/goods/quickSearch` //查看商品列表
export const queryMyGoodsList = `${meatUrl}/company/search1` //查询店铺的（普通）商品列表（等级排序）
export const getStoreGoodsUrl = `${meatUrl}/goods/getStore` // 查询店铺中心的（普通）商品列表（等级排序）
export const addGoodsUrl = `${meatUrl}/manage/goods/add` //添加商品
export const queryMyWhiteBarList = `${meatUrl}/manage/goods/stock/mine` //查看店铺白条
export const addMyWhiteBarList = `${meatUrl}/manage/goods/stock/add1` //添加白条
export const deleteGoodsUrl = `${meatUrl}/manage/goods/delete` // 删除商品

export const addStockUrl = `${meatUrl}/manage/goods/addStock` // 添加白条
export const goodUnsellsUrl = `${meatUrl}/manage/goods/unsell` // 商品上下架

// 角色权限
export const getAuthRoleUrl = `${meatUrl}/manage/auth/getRole` // 获取用户角色权限

// 店铺
export const queryStoreList = `${meatUrl}/reco/getAllStore`
export const queryStoreEmployee = `${meatUrl}/manage/emp/getMine` //查询店铺员工
export const addEmpUrl = `${meatUrl}/manage/emp/add` //添加员工
export const queryStoreEmpCount = `${meatUrl}/manage/count/dateEmpCount` //查询店铺员工交易信息

//普通商品
export const queryGoodsDetailUrl = `${meatUrl}/goods/get` //查询商品详情
export const getGqProductDetail = `${meatUrl}/gqxx/get` //查看供需订单详情
    //评论
export const getEvaluateMsgListUrl = `${meatUrl}/appraises/list`

//登录
export const login = `${meatUrl}/user/login`;

//退出
export const loginOut = `${meatUrl}/user/logout`;


// 地址
export const addAddressUrl = `${meatUrl}/address/add` // 添加收货地址
export const updateAddressUrl = `${meatUrl}/address/update` // 添加收货地址
export const batchDelAddress = `${meatUrl}/address/batchDel` // 删除收货地址
export const queryAddressListUrl = `${meatUrl}/address/mine` // 查询我的收货地址列表
export const queryDefaultAddressUrlss = `${meatUrl}/address/getDefault` // 获取自己的默认收货地址

//下单
export const addProductOrderUrl = `${meatUrl}/order/addP` // 白条下单
export const addClassifyGoods = `${meatUrl}/order/addGoods` // 普通品类商品下单接口
export const getOutBillUrl = `${meatUrl}/order/getOutBill` // 根据订单主键ID获取出库单信息

//订单及支付

export const queryManagerOrderListUrl = `${meatUrl}/manage/order/listo` //卖家订单
export const deleteOrderUrl = `${meatUrl}/order/delete` // /删除订单
export const queryOrderListUrl = `${meatUrl}/order/list` // 查询订单列表
export const sendPayVerifyCodeUrl = `${meatUrl}/trade/addCardPay` //首次绑卡或者使用已有银行卡支付发送验证码
export const confirmPayVerifyUrl = `${meatUrl}/trade/payByCard` //输入验证码确认绑卡并支付

export const toEbank = `${meatUrl}/trade/toEbank` //网上银行支付
export const listBankCardUrl = `${meatUrl}/manage/user/bankCardList` //查询个人/企业银行卡列表
export const getStoreAccountUrl = `${meatUrl}/wallet/getStoreAccount` // 查询店铺账户余额
export const payOrderUrl = `${meatUrl}/trade/add` // 支付订单接口(支付前查询)
export const balancePayUrl = `${meatUrl}/trade/ldBalancePay` // 账户余额支付
export const storeBanList = `${meatUrl}/wallet/storeBanList` //查询自己店铺（作为充值方）的预付款详情或者列表
export const usList = `${meatUrl}/wallet/usList` //查询店铺用户的预付款余额列表
export const getCust = `${meatUrl}/client/getCust` //查询某个店铺某个客户的预付款余额以及货到付款权限
export const getUSBySId = `${meatUrl}/wallet/getUSBySId` //预付款查询某个店铺下所有的店铺类型的客户的列表
export const sendOrderUrl = `${meatUrl}/manage/order/send` // 卖家发货
export const setOrderUrl = `${meatUrl}/manage/order/setOrder` // 设置订单单价及总重量
export const respondRefund = `${meatUrl}/manage/order/checkRefund` // 卖家操作退款 type 1同意 2拒绝
export const confirmReceiveOrderUrl = `${meatUrl}/order/confirm` // 确认收货
export const listWalletRecordUrl = `${meatUrl}/trade/listTradeDetail` //查询钱包流水列表
export const accountFrozenListUrl = `${meatUrl}/manage/wallet/bfList` //查询冻结金额明细
export const addPrepay = `${meatUrl}/order/addPrepay` //提交预付款充值订单
export const avalRecharge = `${meatUrl}/wallet/avalRecharge` //解锁预付款冻结金额
export const isNewRechargeUser = `${meatUrl}/wallet/checkPre` //查询是否是预付款新用户

//发票
export const addInvoiceUrl = `${meatUrl}/invoice/add` // 添加发票
export const queryMyInvoiceUrl = `${meatUrl}/invoice/mine` // 查询发票列表
export const getInvoiceDetailUrl = `${meatUrl}/invoice/get` // 查询发票详情
export const deleteInvoiceUrl = `${meatUrl}/invoice/delete` // 删除发票
export const updateInvoiceUrl = `${meatUrl}/invoice/update` // 修改发票

//查询
export const queryCompanyListUrl = `${meatUrl}/company/list` // 按类查询公司
export const queryCompanyGetUrl = `${meatUrl}/company/get` // 查询公司详情

//认证
export const newAddPersonAuth = `${meatUrl}/cert/addPerson` // 提交个人认证
export const newAddStoreAuth = `${meatUrl}/cert/addStore` // 企业店铺认证【包括不通过继续提交】
export const newAddBelongAuth = `${meatUrl}/cert/addBelongAuth` //提交认证(屠宰场名下的店铺认证)【包括不通过继续提交】
export const newQueryMyAuth = `${meatUrl}/cert/myAuth` //获取本人的认证信息详情


//肉联所供需
export const publishSupplyApi = `${meatUrl}/gqxx/create` //发布供应
export const applygetListApi = `${meatUrl}/gqxx/getList` //查询供应

//查询店铺详情
export const queryStoreDateUrl = `${meatUrl}/company/store/get` // 查询店铺详情
export const getGoodsUrl = `${meatUrl}/goods/getGoods` // 查询商品列表信息
export const storeAttentUrl = `${meatUrl}/like/attent` // 关注取消店铺
export const updateGoodsUrl = `${meatUrl}/manage/goods/update` // 设置商品价格

//导出
export const tradeMonthUrl = `${meatUrl}/manage/export/tradeMonth` //按照月导出月账单
export const tradeCountUrl = `${meatUrl}/manage/export/tradeCount` //店铺年月周日交易统计导出

export const addRecharge = `${meatUrl}/order/addRecharge` //提交店铺余额充值订单

//收付款明细导出
export const receipt_detail = `${meatUrl}/manage/export/receipt_detail` //导出收款付款明细

//首页展示推荐

export const pcGetHomerecomentStore = `${meatUrl}/reco/manage/getAllStore` // pc首页展示推荐店铺
    //下载app的地址
export const appDownLoadUrl = 'https://android.myapp.com/myapp/detail.htm?apkName=com.bjssdjny.meat&ADTAG=mobile'

export const addStockGoodsUrl = `${meatUrl}/manage/goods/addStock` // 增加普通商品库存（关联白条和普通商品
export const getMineWhiteBarListUrl = `${meatUrl}/manage/goods/stock/mine` // 查询某店铺的各类型的白条
export const storeWithdraw = `${meatUrl}/wallet/withdrawal` // 商家提现（除了挂名店铺）


//获取电子回单base64
export const transBill = `${meatUrl}/manage/order/transBill` //获取电子回单base64
export const transBilPc = `${meatUrl}/manage/order/transBill/pc` //获取电子回单url

//微信支付
export const createOderCode = `${meatUrl}/order/createOderCode`

export const setEmpRoleUrl = `${meatUrl}/manage/auth/setUser` // 设置员工权限，临时
export const listRoleUnderMeUrl = `${meatUrl}/manage/auth/listRole` // 查询本人权限以下角色列表
export const delEmpUrl = `${meatUrl}/manage/emp/del` // 删除员工


//多商品改价
export const setOrderList = `${meatUrl}/manage/order/setOrderList` //多商品改价

//商品管理拖动商品排序
export const storeSort = `${meatUrl}/manage/goods/storeSort` //商品管理拖动商品排序

//绑卡

export const bindCompanyCardUrl = `${meatUrl}/manage/user/bindCompanyCard` //企业绑定银行卡
export const alipayCardbinValidateUrl = `https://ccdcapi.alipay.com/validateAndCacheCardInfo.json`
export const childStoreWithdraw = `${meatUrl}/wallet/withdrawalApply` // 挂名店铺申请提现
export const addWtdCard = `${meatUrl}/manage/wallet/addWtdCard` //添加挂名店铺提现银行卡


//店铺设置密码
export const setStorePayPwdUrl = `${meatUrl}/wallet/setStorePayPwd` // 设置店铺密码
export const setPayPwdUrl = `${meatUrl}/wallet/setPayPwd` // 设置用户支付密码（以及预付款密码）


export const getStoreWdl_listUrl = `${meatUrl}/manage/wallet/wdl_list` // 肉联厂查询提现申请
export const checkWithdrawalUrl = `${meatUrl}/manage/wallet/checkWithdrawal` // 肉联厂审核店铺申请
export const uploadVoucherUrl = `${meatUrl}/manage/wallet/uploadVoucher` // 上传转账凭证


export const updatePassWordUrl = `${meatUrl}/user/updatePassWord` // 修改用户密码
export const loginWithCodeUrl = `${meatUrl}/user/loginByPhone` //根据手机验证码登录
export const updatePwdWithCodeUrl = `${meatUrl}/user/setPwdByPhone` //根据验证码修改密码
export const resetPayPwd = `${meatUrl}/wallet/resetPayPwd` // 更新用户支付密码（已短信验证码的方式）
export const resetStorePayPwd = `${meatUrl}/wallet/resetStorePayPwd` // 更新店铺支付密码（已短信验证码的方式）

export const custlist = `${meatUrl}/client/custlist` //查询某个店铺客户的列表包含预付款余额
export const listClientUrl = `${meatUrl}/client/list` //查询客户列表
export const addMemoUrl = `${meatUrl}/client/addMemo` //添加客户备忘
export const addClientUrl = `${meatUrl}/client/addClient` //添加客户
export const updateClientUrl = `${meatUrl}/client/update` //编辑客户
export const getClientUrl = `${meatUrl}/client/get` //获取客户详情及备忘列表



export const setCustDisc = `${meatUrl}/client/setCustDisc` //管理员或(销售)业务员选择(多个)客户，对(多个商品)商品进行三选一的设置；
export const discList = `${meatUrl}/client/discList` //筛选及查询某店铺的所有客户的所有商品优惠设置信息；
export const batchDelCustDisc = `${meatUrl}/client/batchDelCustDisc` //管理员或(销售)业务员删除某些客户或某些商品的优惠设置；








export const searchUserUrl = `${meatUrl}/user/search` //搜索用户

export function getDate(s) {
    var date = new Date(s);
    var Y = date.getFullYear();
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    var D = date.getDate();
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    // console.log(Y + M + D + h + m + s);
    return `${Y}/${M}/${D}`
}

export function getImageUrl(url, size = 'b') { //bms
    if (!url) {
        return undefined
    }
    if (/^http/.test(url) || /^file/.test(url) || /^content/.test(url)) {
        return url
    }
    if (size === 'o') return `http://${domain}/${url}`

    return `${baseUrl}/${size}/${url}`
}

export function getCity(areaId) {
    let value = "国外";
    _City.forEach(function(item, index) {
        if (areaId == item.value) {
            value = item.label;
            return;
        }
    });
    return value;
}


export function getAreaByAreaId(areaId, getAllCode) {
    if (!areaId) {
        return {
            province: '未知',
            city: '未知',
            area: '未知'
        }
    } else if ((!isNaN(areaId)) && (areaId.length != 6)) {
        return {
            province: '国外',
            city: '国外',
            area: '国外'
        }
    } else if (isNaN(areaId)) {
        return {
            province: areaId,
            city: areaId,
            area: areaId
        }
    }

    areaId = String(areaId)
    let provinceId = areaId.substr(0, 2) + '0000'
    let cityId = areaId.substr(0, 4) + '00'
    let province = _City.find(item => item.value === provinceId)
    let { label: provinceLabel, value: provinceValue } = province
    if (getAllCode) {
        if (provinceId === areaId) return [provinceValue, provinceValue, provinceValue]
    }
    if (provinceId === areaId) return {
        province: provinceLabel,
        city: provinceLabel,
        area: provinceLabel
    }
    let city = null
    city = province.children.find(item => item.value === cityId)
    if (province.children.length == 1) {
        city = province.children[0]
    }
    const { label: cityLabel, value: cityValue } = city ? city : { label: '' }
    if (getAllCode) {
        if (cityId === areaId) return [provinceValue + '', cityValue + '', cityValue + '']
    }
    if (cityId === areaId) return {
        province: provinceLabel,
        city: cityLabel,
        area: cityLabel
    }

    const area = city ? city.children.find(item => item.value === areaId) : { label: '' }
    const { label: areaLabel, value: areaValue } = area
    if (getAllCode) {
        return [provinceValue + '', cityValue + '', areaValue + '']
    }
    return {
        province: provinceLabel,
        city: cityLabel,
        area: areaLabel
    }
}

//临时得
export function formateDate2(date1, index, type, type2) {

    if (!isBeijing && date1) {
        //   2019-12-01 00:00:00   1575129600000
        // 2020-01-01 00:00:00   1577808000000
        // 2019-01-01 00:00:00   1546272000000
        //2020-12-18 15:45:19 1608267409000

        // 30天的时间戳：
        // 30*60*60*24*1000
        // 一年的360*60*60*24*1000
        let jg = 14 * 60 * 60 * 1111
        let t = ''
        if (type == 1) {
            if (type2) {
                console.log(2)
                jg = 16 * 60 * 60 * 1111
            } else {
                console.log(1)
                jg = 14 * 60 * 60 * 1111
            }
            //信息发布时间
            if (!isNaN(index)) {
                t = parseInt(1608267409000 - (index + 1) * jg + 123456)
            }
        } else if (type == 2) {
            // 信息有效时间
            if (!isNaN(index)) {
                t = parseInt(1608267409000 + Math.random() * 250 * 60 * 60 * 24 * 1000)
            }
        } else if (type == 3) {
            //商品上架时间
        } else if (type == 4) {
            //店铺创建时间
        }

        date1 = t

    }
    let time = function(inputTime) {
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    };
    return time(date1)
}

export const breedData = [
    { label: '良种猪', value: '良种猪' },
    { label: '内三元', value: '内三元' },
    { label: '外三元', value: '外三元' },
    { label: '土杂猪', value: '土杂猪' },
    { label: '良杂猪', value: '良杂猪' },
    { label: '黑猪', value: '黑猪' },
    { label: '花猪', value: '花猪' },
    { label: '特种猪', value: '特种猪' },
]

export const gradeData = [
    { label: '一级', value: 1 },
    { label: '二级', value: 2 },
    { label: '三级', value: 3 },
    { label: '四级', value: 4 },
    { label: '五级', value: 5 }
]

export const unitData = [
    { label: 'kg', value: 'kg' },
    { label: '片', value: '片' },
    { label: '头', value: '头' },
    { label: '箱', value: '箱' },
    { label: '瓶', value: '瓶' },
    { label: '罐', value: '罐' },
    { label: '只', value: '只' },
    { label: '桶', value: '桶' },
    { label: '吨', value: '吨' },
    { label: '件', value: '件' },
    { label: '包', value: '包' },
  {label:'盒',value:'盒'},
  
]
export const internationCity = [
    { label: '德国', value: '德国' },
    { label: '丹麦', value: '丹麦' },
    { label: '西班牙', value: '西班牙' },
    { label: '荷兰', value: '荷兰' },
    { label: '英国', value: '英国' },
    { label: '美国', value: '美国' },
    { label: '法国', value: '法国' },
    { label: '爱尔兰', value: '爱尔兰' },
    { label: '新西兰', value: '新西兰' },
    { label: '智利', value: '智利' },
    { label: '阿根廷', value: '阿根廷' },
    { label: '乌拉圭', value: '乌拉圭' },
    { label: '加拿大', value: '加拿大' },
    { label: '澳大利亚', value: '澳大利亚' },
    { label: '巴西', value: '巴西' },
    { label: '墨西哥', value: '墨西哥' },
    { label: '印度', value: '印度' },
    { label: '缅甸', value: '缅甸' },
    { label: '巴基斯坦', value: '巴基斯坦' },
    { label: '印尼', value: '印尼' },
    { label: '马来西亚', value: '马来西亚' },
    { label: '西非', value: '西非' },
    { label: '乌克兰', value: '乌克兰' },
    { label: '俄罗斯', value: '俄罗斯' },
    { label: '哈萨克斯坦', value: '哈萨克斯坦' },
    { label: '比利时', value: '比利时' },
    { label: '挪威', value: '挪威' },
    { label: '菲律宾', value: '菲律宾' },
    { label: '爱尔兰', value: '爱尔兰' },
    { label: '苏格兰', value: '苏格兰' },
    { label: '法罗群岛', value: '法罗群岛' },
    { label: '冰岛', value: '冰岛' },
    { label: '日本', value: '日本' },
    { label: '韩国', value: '韩国' },
    { label: '孟加拉', value: '孟加拉' },
    { label: '厄瓜多尔', value: '厄瓜多尔' },
    { label: '越南', value: '越南' },
    { label: '塞尔维亚', value: '塞尔维亚' },
    { label: '哥斯达黎加', value: '哥斯达黎加' },
    { label: '南非', value: '南非' },
    { label: '罗马尼亚', value: '罗马尼亚' },
    { label: '蒙古', value: '蒙古' },
    { label: '朝鲜', value: '朝鲜' },
    { label: '芬兰', value: '芬兰' },
    { label: '泰国', value: '泰国' },
    { label: '白俄罗斯', value: '白俄罗斯' },
    { label: '波兰', value: '波兰' },
    { label: '土耳其', value: '土耳其' },
    { label: '索马里', value: '索马里' },
    { label: '匈牙利', value: '匈牙利' },
    { label: '纳米比亚', value: '纳米比亚' }
]


export const internationCity2 = [
    { label: '中国', value: '中国' },
    { label: '德国', value: '德国' },
    { label: '丹麦', value: '丹麦' },
    { label: '西班牙', value: '西班牙' },
    { label: '荷兰', value: '荷兰' },
    { label: '英国', value: '英国' },
    { label: '美国', value: '美国' },
    { label: '法国', value: '法国' },
    { label: '爱尔兰', value: '爱尔兰' },
    { label: '新西兰', value: '新西兰' },
    { label: '智利', value: '智利' },
    { label: '阿根廷', value: '阿根廷' },
    { label: '乌拉圭', value: '乌拉圭' },
    { label: '加拿大', value: '加拿大' },
    { label: '澳大利亚', value: '澳大利亚' },
    { label: '巴西', value: '巴西' },
    { label: '墨西哥', value: '墨西哥' },
    { label: '印度', value: '印度' },
    { label: '缅甸', value: '缅甸' },
    { label: '巴基斯坦', value: '巴基斯坦' },
    { label: '印尼', value: '印尼' },
    { label: '马来西亚', value: '马来西亚' },
    { label: '西非', value: '西非' },
    { label: '乌克兰', value: '乌克兰' },
    { label: '俄罗斯', value: '俄罗斯' },
    { label: '哈萨克斯坦', value: '哈萨克斯坦' },
    { label: '比利时', value: '比利时' },
    { label: '挪威', value: '挪威' },
    { label: '菲律宾', value: '菲律宾' },
    { label: '爱尔兰', value: '爱尔兰' },
    { label: '苏格兰', value: '苏格兰' },
    { label: '法罗群岛', value: '法罗群岛' },
    { label: '冰岛', value: '冰岛' },
    { label: '日本', value: '日本' },
    { label: '韩国', value: '韩国' },
    { label: '孟加拉', value: '孟加拉' },
    { label: '厄瓜多尔', value: '厄瓜多尔' },
    { label: '越南', value: '越南' },
    { label: '塞尔维亚', value: '塞尔维亚' },
    { label: '哥斯达黎加', value: '哥斯达黎加' },
    { label: '南非', value: '南非' },
    { label: '罗马尼亚', value: '罗马尼亚' },
    { label: '蒙古', value: '蒙古' },
    { label: '朝鲜', value: '朝鲜' },
    { label: '芬兰', value: '芬兰' },
    { label: '泰国', value: '泰国' },
    { label: '白俄罗斯', value: '白俄罗斯' },
    { label: '波兰', value: '波兰' },
    { label: '土耳其', value: '土耳其' },
    { label: '索马里', value: '索马里' },
    { label: '匈牙利', value: '匈牙利' },
    { label: '纳米比亚', value: '纳米比亚' }
]

export const internationCity3 = [
    { label: '中国', value: '中国' },
    { label: '德国', value: '德国' },
    { label: '丹麦', value: '丹麦' },
    { label: '西班牙', value: '西班牙' },
    { label: '荷兰', value: '荷兰' },
    { label: '英国', value: '英国' },
    { label: '美国', value: '美国' },
    { label: '法国', value: '法国' },
    { label: '爱尔兰', value: '爱尔兰' },
    { label: '新西兰', value: '新西兰' },
    { label: '智利', value: '智利' },
    { label: '阿根廷', value: '阿根廷' },
    { label: '乌拉圭', value: '乌拉圭' },
    { label: '加拿大', value: '加拿大' },
    { label: '澳大利亚', value: '澳大利亚' },
    { label: '巴西', value: '巴西' },
    { label: '墨西哥', value: '墨西哥' },
    { label: '印度', value: '印度' },
    { label: '缅甸', value: '缅甸' },
    { label: '巴基斯坦', value: '巴基斯坦' },
    { label: '印尼', value: '印尼' },
    { label: '马来西亚', value: '马来西亚' },
    { label: '西非', value: '西非' },
    { label: '乌克兰', value: '乌克兰' },
    { label: '俄罗斯', value: '俄罗斯' },
    { label: '哈萨克斯坦', value: '哈萨克斯坦' },
    { label: '比利时', value: '比利时' },
    { label: '挪威', value: '挪威' },
    { label: '菲律宾', value: '菲律宾' },
    { label: '爱尔兰', value: '爱尔兰' },
    { label: '苏格兰', value: '苏格兰' },
    { label: '法罗群岛', value: '法罗群岛' },
    { label: '冰岛', value: '冰岛' },
    { label: '日本', value: '日本' },
    { label: '韩国', value: '韩国' },
    { label: '孟加拉', value: '孟加拉' },
    { label: '厄瓜多尔', value: '厄瓜多尔' },
    { label: '越南', value: '越南' },
    { label: '塞尔维亚', value: '塞尔维亚' },
    { label: '哥斯达黎加', value: '哥斯达黎加' },
    { label: '南非', value: '南非' },
    { label: '罗马尼亚', value: '罗马尼亚' },
    { label: '蒙古', value: '蒙古' },
    { label: '朝鲜', value: '朝鲜' },
    { label: '芬兰', value: '芬兰' },
    { label: '泰国', value: '泰国' },
    { label: '白俄罗斯', value: '白俄罗斯' },
    { label: '波兰', value: '波兰' },
    { label: '土耳其', value: '土耳其' },
    { label: '索马里', value: '索马里' },
    { label: '匈牙利', value: '匈牙利' },
    { label: '纳米比亚', value: '纳米比亚' }
]


export const roleSetting = {
    0: "管理员",
    1: "库管员",
    2: "销售员",
    3: "财务会计",
    4: "普通员工",
    5: "出纳",
    6: "采购员",
}


// WEBPACK FOOTER //
// ./src/api/api.js